<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     新建角色
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog class="role-editor" :title="!roleid? '新建角色' : '编辑角色'" :visible.sync="dialogShow" width="600px" v-loading="postloading" :close-on-click-modal="false" :modal-append-to-body="false">
    <template>
      <el-form ref="roleForm" :model="roleFormData" :rules="rules" label-width="100px" label-position="left" class="f-form">
        <el-form-item prop="title" label="角色名称" style="width: 100%">
          <el-input :controls="false" v-model="roleFormData.title" clearable placeholder="角色名称" style="width: 100%" />
        </el-form-item>
        <div style="height: 400px">
          <el-scrollbar style="height: 100%" v-loading="loading">
            <el-tree ref="menuTree" :data="menulist" :default-checked-keys="roleFormData.permission" show-checkbox default-expand-all node-key="id" highlight-current :props="defaultProps"> </el-tree>
          </el-scrollbar>
        </div>
      </el-form>

      <div class="mt-lg text-center">
        <el-button class="extend" plain @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="success" :loading="posting" @click="submit">提交</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { rolePostApi, roleGetApi } from '@/api/fam/famMemberApi'

export default {
  name: 'RoleEditor',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    roleid: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      rules: {
        title: [{ required: true, message: '请填写角色名称', trigger: 'blur' }]
      },
      postloading: false,
      loading: false,
      posting: false,
      roleFormData: {
        title: '',
        permission: []
      },

      defaultProps: {
        children: 'children',
        label: 'title'
      },
      menulist: []
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },

  created() {
    this.fetchData()
  },

  mounted() {},

  methods: {
    fetchData() {
      this.loading = true
      roleGetApi({ roleid: this.roleid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.menulist = res.data.menus
          this.roleFormData.permission = res.data.permission.menu_ids
          this.roleFormData.title = res.data.title
        } else {
          this.$message.error(res.message)
        }
      })
    },

    submit() {
      Promise.all([this.$refs['roleForm'].validate()]).then(() => {
        // 通过表单校验
        this.postLoading = true
        let arr = []
        this.$refs.menuTree.getCheckedNodes().forEach(item => {
          arr.push(item.id)
        })
        this.roleFormData['permission'] = { menu_ids: arr }
        if (this.roleid) this.roleFormData['roleid'] = this.roleid
        rolePostApi(this.roleFormData).then(res => {
          this.postLoading = false
          if (!res.errno) {
            this.$message.success(this.roleid == 0 ? '角色创建成功' : '角色编辑成功')
            this.dialogShow = false
            this.$emit('change')
          } else {
            this.$message.error(res.message)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.role-editor {
  .f-form {
    padding: 0px 30px;
  }
  .el-input-number /deep/.el-input__inner {
    text-align: left;
  }
  /deep/.el-form-item__label {
    color: rgba(16, 16, 16, 1);
  }
}
</style>
